import { useEffect, useState } from "react";
import Footer from "../components/Footer";
import MenuDesktopHorizontal from "../components/MenuDesktopHorizontal";
import OneCommentaire from "../components/OneCommentaire";
import SkeletonComment from "../components/SkeletonComment";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { client } from "../client.js";

const LivreDOr = () => {
  const [allCommentaire, setAllCommentaire] = useState(null);
  const [commentaire, setCommentaire] = useState("");
  const [pseudo, setPseudo] = useState("");
  const [loadingBoutton, setLoadingBoutton] = useState(false);

  // gerer les notification des commenatire envoyer
  const notify = () => {
    toast.success("Commenatire envoyer avec succès, Merci pour votre avis!!!", {
      position: "top-center",
      autoClose: 7000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };

  const sendCommentaire = async (e) => {
    e.preventDefault();

    setLoadingBoutton(true);

    try {
      await client
        .create({
          _type: "commentaire",
          post: {
            _type: "reference",
            // _ref: _id,
          },
          commentaire,
          pseudo,
        })
        .then((response) => {
          setLoadingBoutton(false);
          notify();
        });
    } catch (err) {
      // return res.status(500).json({message: `Nous n'avons pas pu soumettre votre commentaire`, err})
    }
    // return res.status(200).json({ message: 'Commentaire envoyer avec succès.' })

    const comment = {
      pseudo: pseudo,
      commentaire: commentaire,
      _createdAtLocal: new Date().toLocaleString("fr-fr", {
        weekday: "long",
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "numeric",
      }),
    };

    setAllCommentaire((el) => [comment, ...el]);

    setCommentaire("");

    localStorage.setItem("pseudo", JSON.stringify(pseudo));
  };

  useEffect(() => {
    // l'appeler les commentaires
    client
      .fetch(
        `*[_type == "commentaire"]{
            _id,
            pseudo,
            commentaire,
            _createdAt,
          } | order(_createdAt desc)`
      )
      .then((data) => {
        setAllCommentaire(data);
      })
      .catch(console.error);

    const items = JSON.parse(localStorage.getItem("pseudo"));
    if (items) {
      setPseudo(items);
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("pseudo", JSON.stringify(pseudo));
  }, [pseudo]);

  // useEffect(() => {

  // }, []);

  return (
    <div className="flex flex-col items-center w-full h-screen relative">
      <div className="flex flex-col relative w-full h-screen pb-40 lg:pb-6 px-8 lg:px-4 items-center max-w-2xl lg:max-w-4xl 2xl:max-w-6xl ecran-2000:max-w-7xl">
        <MenuDesktopHorizontal />

        <div className="pt-24 lg:pt-6 flex-1 flex flex-col items-center w-full text-white">
          <div className="flex flex-col items-center w-full space-y-8">
            <ToastContainer />
            <span
              style={{ marginTop: 0 }}
              className="texte-apropos text-4xl relative text-[#c792cf] font-semibold tracking-tighter font-[Yanone Kaffeesatz] after:content-[''] 
              after:absolute after:block after:h-1 after:bg-[#c792cf] 
              after:w-full"
            >
              Livre d'Or
            </span>

            <p className="text-gray-300 text-xs text-center select-none">
              Cette page est réservée aux commentaires, alors faites preuve d'indulgence ou tout simplement vous pouvez me féliciter.
            </p>

            <ul className="w-full grid grid-cols-1 gap-5 md:grid-cols-2">
              <div className="flex items-center flex-col w-auto col-span-2 space-y-8">
                <form
                  onSubmit={sendCommentaire}
                  className="w-full flex flex-col space-y-3"
                >
                  <textarea
                    type="text"
                    style={{ minHeight: "112px", maxHeight: "350px" }}
                    className="w-full h-28 bg-transparent rounded-md pl-4 outline-none border-2 border-gray-500 focus:border-[#82aac1]"
                    placeholder="Commentaires"
                    name="commentaire"
                    value={commentaire}
                    onChange={(e) => setCommentaire(e.target.value)}
                    required
                  />
                  <input
                    type="text"
                    className="w-full h-12 bg-transparent rounded-md pl-4 outline-none border-2 border-gray-500 focus:border-[#82aac1]"
                    placeholder="pseudo"
                    name="pseudo"
                    value={pseudo}
                    onChange={(e) => setPseudo(e.target.value)}
                    required
                  />
                  <input
                    type="submit"
                    className="bg-[#82aac1] h-12 rounded-md text-lg md:w-60 cursor-pointer"
                    value={loadingBoutton ? "En cour..." : "Envoyer"}
                  />
                </form>

                {/* affichier les commentaires */}
                <ul className="w-full flex flex-col border-t border-gray-700 pt-3 space-y-3">
                  {allCommentaire !== null
                    ? allCommentaire.map((comment, id) => (
                        <OneCommentaire key={id} comment={comment} />
                      ))
                    : [12, 6, 8, 10, 9, 2].map((_, id) => (
                        <SkeletonComment key={id} />
                      ))}
                </ul>
              </div>
            </ul>
          </div>
        </div>

        {/* footer */}
        <div className="lg:hidden pb-20">
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default LivreDOr;
